import { render, staticRenderFns } from "./FullPageDigiLibraryAdminDashboard.vue?vue&type=template&id=328aa455&"
import script from "./FullPageDigiLibraryAdminDashboard.vue?vue&type=script&lang=js&"
export * from "./FullPageDigiLibraryAdminDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FullPageDigiLibraryAdminDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports